module.exports = __webpack_public_path__ + "static/media/error-page-top-left-cloud.e31a6569.svg";